const CamilleCustomTiers = {
  cart: null,
  initialized: false,
  LOADING: false,
  
  async init(cart){
    this.tiers = CAMILLE_REBUY_TIERS;
    this.cart = cart;

    if(this.initialized){
      this.onCartChange();
      return;
    }

    this.initialized = true;

    await this.collectProducts();

    setTimeout(function(){
      CamilleCustomTiers.updateTexts();
      CamilleCustomTiers.handleGiftWrapping();
      CamilleCustomTiers.onCartChange();
    }, 500);
  },

  /**
   * Updates the texts in the DOM elements.
   */
  updateTexts(){
    document.querySelector('#cb-gift-wrapping-toggle__label').innerHTML = CAMILLE_REBUY_CONFIG.GIFT_WRAPPING_TEXT;
    document.querySelector('#cb-product-list__title').innerHTML = CAMILLE_REBUY_CONFIG.PRODUCT_LIST_TITLE;
  },

  /**
   * Handles the gift wrapping functionality.
   */
  handleGiftWrapping(){
    const giftWrappingInput = document.querySelector('#cb-gift-wrapping-toggle__input');
    if (giftWrappingInput){
      const isGiftWrappingInCart = CamilleCustomTiers.cart.cart.items.find((item) => {
        return item.properties && item.properties.__gift_wrapping;
      });

      if (typeof isGiftWrappingInCart !== 'undefined'){
        giftWrappingInput.checked = true;
      }

      giftWrappingInput.addEventListener('change', async function(event){
        const isChecked = event.currentTarget.checked;

        if (isChecked){
          await window.Rebuy.Cart.addItem({
            id: CAMILLE_REBUY_CONFIG.GIFT_WRAPPING_VARIANT_ID,
            quantity: 1,
            properties: {
              __gift_wrapping: true
            }
          });
        } else {
          const giftWrapping = CamilleCustomTiers.cart.cart.items.find((item) => {
            return item.properties && item.properties.__gift_wrapping;
          });

          if (typeof giftWrapping !== 'undefined'){
            await window.Rebuy.Cart.removeItem(giftWrapping);
          }
        }
      });
    }
  },

  /**
   * Collects products from tiers and fetches additional product data from the server.
   * @returns {Array<Object>} An array of products with their respective data.
   */
  async collectProducts(){
    let products = [];
    this.tiers.forEach((tier) => {
      if (tier.products){
        tier.products.forEach((product) => {
          console.log('Product ---', tier);
          products.push({
            product_id: product,
            minimum: Rebuy.Cart.formatMoney(tier.min * 100)
          });
        });
      }
    });

    //products = this._removeDuplicates(products);

    const response = await fetch('/collections/'+CAMILLE_REBUY_CONFIG.FREE_GIFT_COLLECTION_HANDLE+'/products.json?limit=500', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'GET'
    });

    const responseBody = await response.json();

    products = products.map((product) => {
      const productData = responseBody.products.find((p) => {
        return p.id == product.product_id;
      });

      if (typeof productData !== 'undefined'){
        return {
          id: product.product_id,
          variantId: productData.variants[0].id,
          title: productData.title,
          image: productData.images.length > 0 ? productData.images[0].src : '',
          price: productData.variants[0].price,
          minimum: product.minimum
        };
      } else {  
        return null;
      }
    });

    products = products.filter((product) => {
      return product !== null;
    });

    CamilleCustomTiers.renderSlider(products);
    return products;
  },

  /**
   * Renders the slider with the given products.
   * 
   * @param {Array} products - The array of products to be rendered in the slider.
   */
  renderSlider(products){
    let template = `<div class="glider-contain">
      <div class="glider">
        <div class="glider-track">`;

        products.forEach((product) => {
          console.log('The Product', product);
          template += `<div
            class="glider__outer glider-slide center visible"
            data-gslide="0">

            <div id="cb-slider-product-${product.id}" class="glider__product-card glider__product-locked">
              <span class="glider__product-card-lock"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="M0 0h24v24H0z" fill="none"/><path d="M6 8V7a6 6 0 1 1 12 0v1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2zm13 2H5v10h14V10zm-8 5.732a2 2 0 1 1 2 0V18h-2v-2.268zM8 8h8V7a4 4 0 1 0-8 0v1z"/></g></svg></span>
              <span class="glider__product-card-checkmark"><svg height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z    M370.9,181.1L231.8,359.6c-1.1,1.1-2.9,3.5-5.1,3.5c-2.3,0-3.8-1.6-5.1-2.9c-1.3-1.3-78.9-75.9-78.9-75.9l-1.5-1.5   c-0.6-0.9-1.1-2-1.1-3.2c0-1.2,0.5-2.3,1.1-3.2c0.4-0.4,0.7-0.7,1.1-1.2c7.7-8.1,23.3-24.5,24.3-25.5c1.3-1.3,2.4-3,4.8-3   c2.5,0,4.1,2.1,5.3,3.3c1.2,1.2,45,43.3,45,43.3l111.3-143c1-0.8,2.2-1.4,3.5-1.4c1.3,0,2.5,0.5,3.5,1.3l30.6,24.1   c0.8,1,1.3,2.2,1.3,3.5C372,179.1,371.5,180.2,370.9,181.1z"/></g></svg></span>

              <div class="glider__product-container">
                <div class="glider__product-card-overlay"></div>
                <button class="glider__product-card-button-overlay" 
                  product="${product.id}" variant="${product.variantId}"></button>
                <div class="rebuy-cart__progress-free-product-image glider__product-image" 
                  style="background-image:url('${product.image}')"></div>
                <div class="rebuy-cart__progress-free-product-title">
                  <span class="glider__product-title">Unlock ${product.title} at ${product.minimum}+</span>
                  <span class="glider__product-pricing">
                    <span>$${product.price}</span>
                    <span>FREE</span>
                  </span>
                </div>
              </div>
            </div>
          </div>`;
        });

    template += `</div>
      </div>

      <button aria-label="Previous" id="glider-prev" class="glider-prev">
      <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg>
      </button>
      <button aria-label="Next" id="glider-next" class="glider-next">
        <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path></svg>
      </button>
    </div>`;

    document.querySelector('#cb-product-slider').innerHTML = template;

    const glider = new Glider(document.querySelector('.glider'), {
      slidesToShow: 1.4,
      slidesToScroll: 1,
      rewind: false,
      draggable: true,
      skipTrack: true,
      arrows: {
        prev: '#glider-prev',
        next: '#glider-next'
      }
    });

    this.registerSliderEvents();
  },

  /**
   * Registers slider events for product cards.
   */
  registerSliderEvents(){
    const buttons = document.querySelectorAll('.glider__product-card-button-overlay');
    buttons.forEach((button) => {
      button.addEventListener('click', async function(event){
        event.preventDefault();

        if (CamilleCustomTiers.LOADING){
          return;
        }

        CamilleCustomTiers.LOADING = true;
        const productId = event.currentTarget.getAttribute('product');
        const variantId = event.currentTarget.getAttribute('variant');

        // Check if the cart already has a free gift to remove it
        const _items = CamilleCustomTiers.cart.cart.items.filter((item) => {
          return item.properties.__free_gift;
        });

        if (_items.length > 0){
          _items.forEach(async(item) => {
            await window.Rebuy.Cart.removeItem(item);
          });
        }

        window.Rebuy.Cart.addItem({
          id: variantId,
          quantity: 1,
          properties: {
            '__free_gift': true
          }
        });

        setTimeout(function(){
          CamilleCustomTiers.LOADING = false;
        }, 500);
        
      });
    });
  },

  /**
   * Retrieves the earned products based on the tiers and cart total price.
   * @returns {Array} An array of earned products.
   */
  getEarnedProducts(){
    let products = [];
    this.tiers.forEach((tier) => {
      const tierCents = tier.min * 100;
      if(typeof tier.products !== 'undefined' && this.cart.cart.total_price >= tierCents){
        products.push(...tier.products);
      }
    });

    return products;
  },

  /**
   * Updates the slider information based on the earned products and cart items.
   */
  updateSliderInfo(){
    const earnedProducts = CamilleCustomTiers.getEarnedProducts();
    console.log('Earned Products', earnedProducts);

    const allProducts = document.querySelectorAll('.glider__product-card');
    const cartItems = this.cart.cart.items;
    const tierInfo = this.getTierInfo();

    if (earnedProducts.length == 0 && tierInfo.offsetToNextTier){
      document.querySelector('#cb-product-list__title').innerHTML = `Add ${tierInfo.offsetToNextTier} to unlock a free gift`;
    } else {
      document.querySelector('#cb-product-list__title').innerHTML = CAMILLE_REBUY_CONFIG.PRODUCT_LIST_TITLE;
    }

    allProducts.forEach(async(product) => {
      const productId = parseInt(product.id.replace('cb-slider-product-', ''));

      console.log('ProductId----', productId);

      const isProductInCart = cartItems.find((item) => {
        return item.properties.__free_gift && item.product_id == productId;
      });

      if (earnedProducts.includes(productId)){
        product.classList.remove('glider__product-locked');
        product.classList.add('glider__product-unlocked');
      } else {
        product.classList.add('glider__product-locked');
        product.classList.remove('glider__product-unlocked');

        // Also remove the item from the cart if it's not earned anymore
        const isItemIncart = CamilleCustomTiers.cart.cart.items.find((item) => {
          return item.properties.__free_gift && item.product_id == productId;
        });

        if (typeof isItemIncart !== 'undefined'){
          await window.Rebuy.Cart.removeItem(isItemIncart);
        }
      }

      if (isProductInCart){
        product.classList.add('glider__product-in-cart');
      } else {
        product.classList.remove('glider__product-in-cart');
      }
    });
  },

  onCartChange(){
    CamilleCustomTiers.updateSliderInfo();
    CamilleCustomTiers.render();
  },

  /**
   * Retrieves the tier information based on the current cart total price.
   * @returns {Object} The current tier information.
   */
  getTierInfo(){
    let currentTier = null;
    let currentTierIndex = null;

    this.tiers.forEach((tier, index) => {
      const tierCents = tier.min * 100;
      if(this.cart.cart.total_price >= tierCents){
        currentTier = tier;
        currentTierIndex = index;
        currentTier.index = index;
      }
    });

    if (!currentTier){
      currentTier = this.tiers[0];
      currentTier.index = 0;
      currentTierIndex = -1;
    }
    
    const nextTier = this.tiers[currentTierIndex + 1];
    if(nextTier){
      const nextTierCents = nextTier.min * 100;
      const percentage = Math.round((this.cart.cart.total_price/nextTierCents) * 100);
      const difference = nextTierCents - this.cart.cart.total_price;

      currentTier.nextMessage = nextTier.message.replace('$$', Rebuy.Cart.formatMoney(difference));
      currentTier.offsetToNextTier = Rebuy.Cart.formatMoney(difference);
      currentTier.percentage = percentage;
      currentTier.nextIndex = currentTierIndex + 1;
    } else {
      currentTier.nextMessage = CAMILLE_REBUY_CONFIG.PROGRESS_COMPLETED_MESSAGE;
      currentTier.percentage = 100;
      currentTier.nextIndex = currentTierIndex;
      currentTier.offsetToNextTier = null;
    }

    return currentTier;
  },

  /**
   * Renders the progress bar based on the tier information.
   */
  render(){
    const tierInfo = this.getTierInfo();

    this.$container = document.querySelector('#cb-customer-bar');

    let template = '<div id="cb-rebuy-app-container">';
      template += `<span class="cb-progress-message">${tierInfo.nextMessage}</span>`;

      let containerClass = '';
      if (tierInfo.nextIndex >= 3){
        containerClass = 'cb-progress__bar--single-bar';
      }

      template += `<div class="cb-progress cb-progress__bar--two-columns ${containerClass}">`;

      if (tierInfo.nextIndex >= 3){ 
        // Display a single bar
        let barStyle = `style="--percentage: ${tierInfo.percentage}%;"`;
        let icon = tierInfo.icon;

        if (tierInfo.percentage >= 100){
          icon = '<svg class="cb-progress-completed__checkmark" height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z    M370.9,181.1L231.8,359.6c-1.1,1.1-2.9,3.5-5.1,3.5c-2.3,0-3.8-1.6-5.1-2.9c-1.3-1.3-78.9-75.9-78.9-75.9l-1.5-1.5   c-0.6-0.9-1.1-2-1.1-3.2c0-1.2,0.5-2.3,1.1-3.2c0.4-0.4,0.7-0.7,1.1-1.2c7.7-8.1,23.3-24.5,24.3-25.5c1.3-1.3,2.4-3,4.8-3   c2.5,0,4.1,2.1,5.3,3.3c1.2,1.2,45,43.3,45,43.3l111.3-143c1-0.8,2.2-1.4,3.5-1.4c1.3,0,2.5,0.5,3.5,1.3l30.6,24.1   c0.8,1,1.3,2.2,1.3,3.5C372,179.1,371.5,180.2,370.9,181.1z"/></g></svg>';
        }

        template += `
            <span class="cb-progress__bar cb-prog ress__bar--filled">
            <span class="cb-progress__bar--container">
              <span class="cb-progress__bar--bg"></span>
              <span class="cb-progress__bar--bg-filled" ${barStyle}></span>
            </span>
            <span class="cb-progress__bar--filled__text">
              <span>${icon}</span>
              </span>
            </span>
          </span>
        `;

      } else {
        this.tiers.forEach((tier, index) => { 
          // Display 3 bars
          if (index < 3){
            let barStyle = '';

            if (index == tierInfo.nextIndex){
              barStyle = `style="--percentage: ${tierInfo.percentage}%;"`;
            }

            if (tierInfo.nextIndex > index){
              barStyle = `style="--percentage: 100%;"`;
            }

            template += `
              <span class="cb-progress__bar cb-progress__bar--filled">
                <span class="cb-progress__bar--container">
                  <span class="cb-progress__bar--bg"></span>
                  <span class="cb-progress__bar--bg-filled" ${barStyle}></span>
                </span>
                <span class="cb-progress__bar--filled__text">
                  <span>${tier.icon}</span>
                  </span>
                </span>
              </span>
            `;
          }
        });
      }

      template += `</div>`;
    template += `</div>`;

    this.$container.innerHTML = template;
  },

  _removeDuplicates(arr){
    return arr.filter((item, index) => arr.indexOf(item) === index); 
  }
};

document.addEventListener('rebuy:cart.change', function(event){
  CamilleCustomTiers.init(event.detail.cart);
});